<template>
  <div>
    <Breadcrumbs title="Clientes"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'CoreClientForm'}">
                  <i class="fa fa-user-plus"></i> Agregar cliente
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                    ref="table"
                    :fields="datatableConfig.fields"
                    :opts="datatableConfig.options"
                    @editClient="editClient"
                    @editStatusObject="editStatusObject">
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
import $ from 'jquery';
window.jQuery = $;
import VdtnetTable from 'vue-datatables-net';
import 'datatables.net-bs4';
import utils from '../../../utils';
import axios from "axios";

export default {
  components: {
    VdtnetTable
  },
  data(){
    return{
      datatableConfig : {
        options: {
          lengthMenu: [10, 25, 50],
          pageLength: 10,
          lengthChange: false,
          processing: true,
          serverSide: true,
          searchDelay: 500,
          fixedHeader: true,
          responsive: true,
          ajax: {
            url: axios.defaults.baseURL + '/api/core/v1.0/client/?format=datatables',
            type: "GET",
            headers: {
              Authorization: 'JWT ' + localStorage.getItem('token')
            },
            dataSrc: (json) => {
              return json['data'];
            }
          },
          language: {
            decimal: "",
            emptyTable: "No hay información",
            info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
            infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
            infoFiltered: "(Filtrado de _MAX_ total entradas)",
            infoPostFix: "",
            thousands: ",",
            lengthMenu: "Mostrar _MENU_ Entradas",
            loadingRecords: "Cargando...",
            processing: "Procesando...",
            search: "Buscar:",
            zeroRecords: "Sin resultados encontrados",
            paginate: {
              first: "Primero",
              last: "Ultimo",
              next: "Siguiente",
              previous: "Anterior"
            }
          },
          "drawCallback": function () {
            // const num_row = $('.dataTables_length');
            $('div.vdtnet-container').removeClass('table-responsive');
            // num_row.find('select').removeClass('custom-select form-control');
            $('.dataTables_paginate').addClass('pull-right mt-2');
            $('.dataTables_info').addClass('mt-2');
          },
        },
        fields: {
          id: {
            data: 'id',
            visible: false,
            searchable: false,
          },
          color: {
            name: 'color',
            label: 'Color',
            data: 'color',
            sortable: false,
            render: function (data, type, row) {
              return `<span class="badge" style="background-color: ${row['color']}"> <i class="fa"></i></span>`
            }
          },
          business_name: {
            name: 'business_name',
            label: 'Nombre',
            data: 'business_name',
            sortable: true,
          },
          rut: {
            name: 'rut',
            label: 'RUT',
            data: 'rut',
            sortable: true,
          },
          path_tracking: {
            visible: false,
            searchable: false,
          },
          status: {
            name: 'status',
            label: 'Estado',
            data: 'status',
            render: function (data, type, row) {
              let status;
              if(row['status']){
                status = '<span class="badge badge-success">Habilitado</span>';
              }else{
                status = '<span class="badge badge-danger">Deshabilitado</span>';
              }
              return status;
            }
          },
          send_email: {
            name: 'send_email',
            label: 'Envío de correos',
            data: 'send_email',
            render: function (data, type, row) {
              let status;
              if(row['send_email']){
                status = '<span class="badge badge-success">Habilitado</span>';
              }else{
                status = '<span class="badge badge-danger">Deshabilitado</span>';
              }
              return status;
            }
          },
          actions: {
            label: 'Acciones',
            isLocal: true,
            render: function (data, type, row) {
              let status;
              if(row['status']){
                status = '<a href="javascript:void(0);" data-action="editStatusObject" title="Deshabilitar"><span class="badge badge-warning"><i class="fa fa-times"></i></span></a>'
              }else{
                status = '<a href="javascript:void(0);" data-action="editStatusObject" title="Habilitar"><span class="badge badge-success"><i class="fa fa-check"></i></span></a>'
              }
              return '' +
                  '<a href="javascript:void(0);" data-action="editClient" title="Modificar"><span class="badge badge-primary"><i class="fa fa-pencil"></i></span></a> ' +
                  `<a href="/tracking/${row['path_tracking']}/" target="_blank" title="Ver Tracking"><span class="badge badge-success"><i class="fa fa-location-arrow"></i></span></a> ` +
                  `<a href="/inventory/${row['path_tracking']}/" target="_blank" title="Inventario Online"><span class="badge badge-primary"><i class="fa fa-archive"></i></span></a> ` +
                  `${status} ` +
                  ''
            }
          }
          // status: { label: 'Estado', sortable: true },
          // action: { label: 'Acción'}
        },
        quickSearch: '',
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalTable);
  },
  mounted() {
    this.intervalTable = setInterval(() => {
      this.$refs.table.reload();
    }, utils.timeRefresh * 1000);
  },
  methods: {
    reloadTable() {
      // ELIMINAOS EL INTERVALO
      clearInterval(this.intervalTable);
      // RECARGAMOS
      this.$refs.table.reload();
      // GENERAMOS EL INTERVALO
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
    },
    doSearch() {
      this.$refs.table.search(this.datatableConfig.quickSearch);
    },
    editClient(data){
      this.$router.push({'name': 'CoreClientFormEdit', params: { objectId: data['id'] }});
    },
    async editStatusObject(row) {
      let oldState = '';
      let newState = '';

      if(row['status']){
        oldState = 'Habilitado';
        newState = 'Deshabilitado';
      } else {
        oldState = 'Deshabilitado';
        newState = 'Habilitado';
      }

      this.$swal({
        title: 'Información',
        type: 'info',
        html: `Estás a punto de <b>cambiar el estado</b> del cliente <b>${row['business_name']}</b> de <b>${oldState}</b> a <b>${newState}</b>.`,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: '#28a745',
        confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
        cancelButtonColor: '#dc3545',
        cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          const path = '/api/core/v1.0/client/' + row['id'] + '/';
          let data = {status: !row['status']};
          const response = await utils.updateObject(path, data);
          // SI SE REALIZA EL CAMBIO
          if (response) {
            await this.$swal({
              title: 'Editado!',
              type: 'success',
              html: `Se ha editado el estado de la categoría de manera correcta.`,
            });
            this.reloadTable();
          }
        }
      });
    },
  },
}
</script>

<style>
.badge-warning {
  color: #ffffff !important;
  background-color: #ffc107;
}
</style>